import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Shiping"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H13C13.8284 1.5 14.5 2.17157 14.5 3V13C14.5 13.8284 13.8284 14.5 13 14.5H3C2.17157 14.5 1.5 13.8284 1.5 13V3ZM6.1665 5.92156V8.00001V10.0785C6.1665 10.3094 6.4165 10.4537 6.6165 10.3383L8.4165 9.29905L10.2165 8.25982C10.4165 8.14435 10.4165 7.85568 10.2165 7.74021L8.4165 6.70098L6.6165 5.66175C6.4165 5.54628 6.1665 5.69062 6.1665 5.92156Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var shiping = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { shiping as default };
